/**
 * Determines if an object is null or undefined.
 * @param obj The object to test.
 * @returns Boolean value.
 */
export function isNullOrUndefined(obj: any): boolean {
        
    return obj === undefined || obj === null;
}